import React, { Fragment, useState, useLayoutEffect, useContext } from "react";
import DataTable from "react-data-table-component";
import { Spinner } from "../../../AbstractElements";
import CustomizerContext from "../../../_helper/Customizer";

/**
 * columns, data, center, fixedHeaderScrollHeight
 */
const CommonDataTable = ({ options, loading }) => {
  const [fixedHeaderScrollHeight, setfixedHeaderScrollHeight] = useState(() => {
    return options.fixedHeaderScrollHeight
      ? options.fixedHeaderScrollHeight
      : "57vh";
  });
  const {mix_background_layout} = useContext(CustomizerContext)

  // const customStyles = {
  //     headCells: {
  //         style: {
  //             paddingLeft: '8px', // override the cell padding for head cells
  //             paddingRight: '8px',
  //         },
  //     },
  //     cells: {
  //         style: {
  //             paddingLeft: '0px', // override the cell padding for data cells
  //             paddingRight: '0px',
  //         },
  //     },
  // };

  useLayoutEffect(() => {
    function updateSize() {
      if (window.innerWidth <= 575.98) {
        setfixedHeaderScrollHeight(51 + "vh");
      } else {
        setfixedHeaderScrollHeight(() => {
          return options.fixedHeaderScrollHeight
            ? options.fixedHeaderScrollHeight
            : 57 + "vh";
        });
      }
    }
    window.addEventListener("resize", updateSize);
    updateSize();
    return () => window.removeEventListener("resize", updateSize);
  }, []);

  return (
    <Fragment>
      <DataTable
        columns={options.columns ? options.columns : []}
        data={options.data ? options.data : []}
        center={options.center ? options.center : false}
        fixedHeader
        fixedHeaderScrollHeight={fixedHeaderScrollHeight}
        pagination={options.notPagination ? false : true}
        progressPending={loading}
        progressComponent={<div className="loader-box" style={{ height: fixedHeaderScrollHeight }}>
          <Spinner attrSpinner={{ className: "loader-3", style: { width: "30px", height: "30px", borderColor: "#39B54A", borderBottomColor: "transparent" } }} />
        </div>}
      // customStyles={customStyles}
      theme={mix_background_layout == "dark-only" ? "dark" : "default"}
      />
    </Fragment>
  );
};
export default CommonDataTable;
